/* ==========================================================
   WM Hero — wm-hero.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.dataset.sectionType !== 'wm-hero') return;
    const video = event.target.querySelector('.wm-hero__video');
    if (video) video.play();
    const phoneEl = event.target.querySelector('.wm-hero__phone');
    if (phoneEl && phoneEl.tagName === 'VIDEO') phoneEl.play();
  });

})();
